var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-box",style:(("backgroundColor: var(--" + _vm.computedColor + ")"))},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(_vm.computedIcon))]),_vm._v(" "),_c('label',{staticClass:"info-label"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }